
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import CrudLayout from "@/layouts/CrudLayout.vue";
import Validation from "@/components/Validation.vue";
import ServiceForm from "@/views/admin/service/ServiceForm.vue";
import FormCreate from "@/views/form/create/FormCreate.vue";

const namespace: string = "service";

@Component({
  components: {
    CrudLayout,
    Validation,
    ServiceForm
  },
  extends: FormCreate
})
export default class ServiceCreate extends Vue {
  public name: string = "ServiceCreate";
  private resourceName = "service";

  @Getter("getError", { namespace })
  protected error: any;

  @Getter("isLoading", { namespace })
  protected loading: any;

  @Getter("isCreated", { namespace })
  protected created: any;

  @Getter("getItem", { namespace })
  protected createdItem: any;

  @Action("create", { namespace })
  protected createItemAction: any;

  @Action("resetCreate", { namespace })
  protected resetAction: any;

  beforeDestroy() {
    this.resetAction();
  }
}
